'use strict';

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = require('babel-runtime/helpers/objectWithoutProperties');

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _createReactClass = require('create-react-class');

var _createReactClass2 = _interopRequireDefault(_createReactClass);

var _contentRepo = require('matrix-js-sdk/lib/content-repo');

var _MatrixClientPeg = require('../../../MatrixClientPeg');

var _MatrixClientPeg2 = _interopRequireDefault(_MatrixClientPeg);

var _Modal = require('../../../Modal');

var _Modal2 = _interopRequireDefault(_Modal);

var _index = require('../../../index');

var _index2 = _interopRequireDefault(_index);

var _Avatar = require('../../../Avatar');

var _Avatar2 = _interopRequireDefault(_Avatar);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/*
Copyright 2015, 2016 OpenMarket Ltd

Licensed under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License.
You may obtain a copy of the License at

    http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software
distributed under the License is distributed on an "AS IS" BASIS,
WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
See the License for the specific language governing permissions and
limitations under the License.
*/
module.exports = (0, _createReactClass2.default)({
    displayName: 'RoomAvatar',

    // Room may be left unset here, but if it is,
    // oobData.avatarUrl should be set (else there
    // would be nowhere to get the avatar from)
    propTypes: {
        room: _propTypes2.default.object,
        oobData: _propTypes2.default.object,
        width: _propTypes2.default.number,
        height: _propTypes2.default.number,
        resizeMethod: _propTypes2.default.string,
        viewAvatarOnClick: _propTypes2.default.bool
    },

    getDefaultProps: function getDefaultProps() {
        return {
            width: 36,
            height: 36,
            resizeMethod: 'crop',
            oobData: {}
        };
    },

    getInitialState: function getInitialState() {
        return {
            urls: this.getImageUrls(this.props)
        };
    },

    componentDidMount: function componentDidMount() {
        _MatrixClientPeg2.default.get().on("RoomState.events", this.onRoomStateEvents);
    },

    componentWillUnmount: function componentWillUnmount() {
        var cli = _MatrixClientPeg2.default.get();
        if (cli) {
            cli.removeListener("RoomState.events", this.onRoomStateEvents);
        }
    },

    componentWillReceiveProps: function componentWillReceiveProps(newProps) {
        this.setState({
            urls: this.getImageUrls(newProps)
        });
    },

    onRoomStateEvents: function onRoomStateEvents(ev) {
        if (!this.props.room || ev.getRoomId() !== this.props.room.roomId || ev.getType() !== 'm.room.avatar') return;

        this.setState({
            urls: this.getImageUrls(this.props)
        });
    },

    getImageUrls: function getImageUrls(props) {
        return [(0, _contentRepo.getHttpUriForMxc)(_MatrixClientPeg2.default.get().getHomeserverUrl(), props.oobData.avatarUrl, Math.floor(props.width * window.devicePixelRatio), Math.floor(props.height * window.devicePixelRatio), props.resizeMethod), // highest priority
        this.getRoomAvatarUrl(props)].filter(function (url) {
            return url != null && url != "";
        });
    },

    getRoomAvatarUrl: function getRoomAvatarUrl(props) {
        if (!props.room) return null;

        return _Avatar2.default.avatarUrlForRoom(props.room, Math.floor(props.width * window.devicePixelRatio), Math.floor(props.height * window.devicePixelRatio), props.resizeMethod);
    },

    onRoomAvatarClick: function onRoomAvatarClick() {
        var avatarUrl = this.props.room.getAvatarUrl(_MatrixClientPeg2.default.get().getHomeserverUrl(), null, null, null, false);
        var ImageView = _index2.default.getComponent("elements.ImageView");
        var params = {
            src: avatarUrl,
            name: this.props.room.name
        };

        _Modal2.default.createDialog(ImageView, params, "mx_Dialog_lightbox");
    },

    render: function render() {
        var BaseAvatar = _index2.default.getComponent("avatars.BaseAvatar");

        /*eslint no-unused-vars: ["error", { "ignoreRestSiblings": true }]*/
        var _props = this.props,
            room = _props.room,
            oobData = _props.oobData,
            viewAvatarOnClick = _props.viewAvatarOnClick,
            otherProps = (0, _objectWithoutProperties3.default)(_props, ['room', 'oobData', 'viewAvatarOnClick']);


        var roomName = room ? room.name : oobData.name;

        return _react2.default.createElement(BaseAvatar, (0, _extends3.default)({}, otherProps, { name: roomName,
            idName: room ? room.roomId : null,
            urls: this.state.urls,
            onClick: this.props.viewAvatarOnClick ? this.onRoomAvatarClick : null,
            disabled: !this.state.urls[0] }));
    }
});
//# sourceMappingURL=RoomAvatar.js.map